<template>
  <section id="search" class="search">
    <SearchForm
      :title="[]"
      :loc="''"
      :wknd="''"
      :params="[]"
      :region="''"
      :page="'lodge'"
    />
    <LodgeHero
      :properties="properties"
      :park="$props.park"
      :images="$props.images"
      :isMobile="isMobile"
      :activeTab="activeTab"
      :track="trackEv"
      @toggleTabs="toggleTabs"
    />
    <LodgeTab
      :tabs="[]"
      :filter="filter"
      :savedFilter="savedFilter"
      :loading="loading"
      :hasBeenResized="hasBeenResized"
      :properties.sync="properties"
      :getData="getResults"
      :count="count"
      :park="$props.park"
      :map="map"
      :isMobile="isMobile"
      :activeTab="activeTab"
      :requestError="requestError"
      :track="trackEv"
      @toggleTabs="toggleTabs"
      @removeResizeFlag="removeResizeFlag"
    />
  </section>
</template>

<script>
import SearchForm from 'shared/searchForm.vue'
import Searchfilter from 'shared/filter.vue'
import LodgeHero from 'comp_lodges/lodgeHero.vue'
import LodgeTab from 'comp_lodges/lodgeTab.vue'

export default {
  data: function () {
    return {
        id: "",
        filter: this.cleanFilter(JSON.parse(JSON.stringify(this.$props.initfilter))),
        savedFilter: {},
        properties: [],
        initialload: true,
        loading: false,
        hasBeenResized: false,
        count: 0,
        noprice: false,
        isMobile: window.innerWidth < 1024,
        activeTab: window.innerWidth < 1024 ? 'mobile' : 'filters',
        requestError: false,
        map: {
            coords: [this.$props.park.lng, this.$props.park.lat],
            zoom: 10,
            minZoom: 3,
            maxZoom: 15
        }
    }
  },
  props: {
      initfilter: {
          type: Object,
          required: true
      },
      park: Object,
      url: String,
      search: Object,
      images: Array
  },
  components: {
      Searchfilter, LodgeHero, LodgeTab, SearchForm
  },
  methods: {
      showError(err) {
        this.requestError = true;
      },
      getRequest() {
          let request = {
              method: "GET",
              credentials: "include",
              headers: {
                  'X-CSRF-TOKEN': st.getCSRFToken()
              }
          };

          return request;
      },
      cleanFilter(filter) {
          const newObj = {};
          for (let i in filter) {
              if (filter.hasOwnProperty(i) && filter[i] !== null && filter[i] !== "" && (filter["caravan"] !== false || filter["lodge"] !== false || filter["cottage"] !== false || filter["apartment"] !== false)) {
                  newObj[i] = filter[i];
              }
          }
          if (newObj["caravan"] && newObj["lodge"] && newObj["cottage"] && newObj["apartment"]) {
            delete newObj["caravan"];
            delete newObj["lodge"];
            delete newObj["cottage"];
            delete newObj["apartment"];
          }
          return newObj;
      },
      pushUrl: function(params) {
          let app = this;
          let url = window.location.href.split('?')[0] + (params.length > 1 ? "?" + params : ""),
              utm = window.location.href.split("utm_source")[1],
              suffix;

          if (app.initialload) {
              document.body.addEventListener("PageReady", function () {
                  suffix = typeof utm !== "undefined" && utm.length > 0 ? "&utm_source" + utm : "";
                  history.pushState({}, document.title, url + suffix);
              });
              app.initialload = false;
          } else {
              history.pushState({}, document.title, url);
          }
      },
      getResults() {
          let app = this;
          let params = st.serialize({ search: app.cleanFilter(app.filter) });
          let baseUrl = app.$props.url.split("?")[0] + "?" + params;

          app.savedFilter = JSON.parse(JSON.stringify(app.filter));
          app.loading = true;

          fetch(baseUrl, app.getRequest())
              .then((resp) => resp.json())
              .then(function(data) {
                  if (data.properties.length > 0) {
                      let date = app.filter.check_in_on;
                      app.properties = data.properties;
                      setTimeout(function(){ app.loading = false }, 500);
                      app.id = data.search;
                      if (typeof date !== "undefined" && date !== null) {
                          app.getPrices();
                      }
                  } else {
                      app.properties = [];
                  }
                  app.pushUrl(params);
              })
              .catch(error => this.showError(error));
      },
      processData(prices) {
          let app = this;
          let props = app.properties;
          for (let i = 0; i < prices.length; i++) {
              for (let j = 0; j < props.length; j++) {
                  if (prices[i].prop_id === props[j].id) {
                      const prop = props[j];
                      const price = prices[i];
                      if (typeof price.discount_price !== "undefined") {
                          Vue.set(prop, "no_price", false);
                          Vue.set(prop, "discount_price", price.discount_price);
                          Vue.set(prop, "original_price", price.original_price);
                          Vue.set(prop, "discount_percentage", price.discount_percentage);
                      } else {
                          Vue.set(prop, "no_price", true);
                      }
                  }
              }
          }
      },
      getPrices() {
        let ids = [],
            app = this,
            props = this.properties,
            url;

        for (let i = 0; i < props.length; i++) {
            ids.push(props[i].id);
        }

        url = st.withPrid("/prices.json?properties=" + ids.join(",") + (app.id !== "" ? "&search=" + app.id : ''));

        fetch(url, app.getRequest())
            .then((resp) => resp.json())
            .then(function(data) {
                app.processData(data);
            });
      },
      trackEv() {
          let app = this;
          // st.tdTrack("uiactions", {
          //     category: "lodge_search_filter",
          //     value: {
          //         filter: app.filter
          //     },
          //     visitor_email_id: window.options.track.visitor_email_id,
          //     tracking_profile_id: window.options.track.tracking_profile_id
          // });
      },

      toggleTabs(str) {
        let app = this;
        app.trackEv(str + "_tab_change");
        app.activeTab = str;
      },

    removeResizeFlag: function() {
      this.hasBeenResized = false;
    },

    resize: function() {
      this.hasBeenResized = true;
      if (window.innerWidth < 1024) {
        this.activeTab = 'mobile';
        this.isMobile = true;
      } else {
        this.activeTab === 'mobile' ? this.activeTab = 'filters' : this.activeTab = this.activeTab;
        this.isMobile = false;
        let openSetions = document.querySelectorAll('.open');
        for (let i = 0; i < openSetions.length; i++) {
          openSetions[i].classList.remove('collapsed');
        }
      }
    },
  },
  mounted: function () {
      this.getResults();
      window.addEventListener('resize', this.resize);
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.search {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 0 4rem;
}


</style>

<style lang="scss">
.skeleton {
  .pet, .ban, .titles, .beds, .sleeps, .view, .region, .name, .total, .was, .was:after, .imgs {
      appereance: none;
      width: auto;
      height: auto;
      overflow: hidden;
      color: transparent !important;
      border: none !important;
      fill: transparent;
      text-shadow: none;
      box-sizing: border-box;
      box-shadow: none;
      will-change: background;
      background-color: #ccc;
      background-image: linear-gradient(90deg, #ddd 0, #e8e8e8 2.5rem, #ddd 5rem);
      background-size: 18.75rem;
      border-radius: 0.125rem;
      animation: shine-lines 1.6s infinite linear;
  }

  .prev,
  .next,
  .bans,
  .revs,
  .ref,
  .itm,
  .sleep-info,
  .view:after,
  .save {
    display: none;
  }

  .slider {
    background: #ddd;
  }
}

@keyframes shine-lines {
  0% {
    background-position: -6.25rem;
  }
  40%, 100% {
    background-position: 8.75rem;
  }
}

</style>
